import { create } from "zustand";
import { AuthApi } from "../utils/api/auth";
import User from "../types/UserType";

interface UserState {
  user: User | null;
  avg: any | null; 
  company: any | null; 
  setUser: (user: User) => void;
  clearUser: () => void;
  setAvg: (avg: any) => void;
  raychatId: any;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  avg: null,
  company: null,
  raychatId: null,
  setUser: (user: User) => set(() => ({ user })),
  setAvg: (avg: any) => set(() => ({ avg })),
  clearUser: () => {
    set(() => ({ user: null }));
    AuthApi.logout().then();
  },
}));